import { Pipe, PipeTransform } from '@angular/core';

import { ContactPerson } from '@planone/shared/util-interfaces';

@Pipe({ name: 'ContactName' })
export class ContactNamePipe implements PipeTransform {
  transform(contact?: ContactPerson) {
    if (typeof contact === 'undefined') {
      return '';
    }

    return (
      (contact.title && contact.title.length > 0 ? contact.title + ' ' : '') +
      (contact.first_name && contact.first_name.length > 0 ? contact.first_name + ' ' : '') +
      (contact.name && contact.name.length > 0 ? contact.name : '')
    );
  }
}
